<template>
    <div>
      <ledes-code-type-list></ledes-code-type-list>
    </div>
  </template>
  <script>
  export default {};
  </script>